import {RECRUITMENT_TYPE_KEYS} from '../../../core/entities/recruitment/constants';
import type {RecruitmentDetailResponse} from '../../../core/entities/recruitment/schema';
import {useGetCompanyInfo} from '../../../core/repositories/companiesRepository';
import {useGetCompanyDetail} from '../../../core/repositories/companyDetailRepository';
import {useReports} from '../../../core/repositories/reportsRepository';

export const useCompanyDataDTO = ({
  recruitmentDetail,
}: {
  recruitmentDetail: RecruitmentDetailResponse;
}) => {
  const company =
    recruitmentDetail.type === RECRUITMENT_TYPE_KEYS.GSSKT_EVENT
      ? recruitmentDetail.companies.find(
          (company) => company.name === '外資就活ドットコム',
        )
      : recruitmentDetail.companies[0];
  // 外資就活主催イベントの場合は、外資就活ドットコムを指定する
  const companyId = company?.id ?? 0;
  const isArchivesPage = recruitmentDetail.archiveID !== 0;
  const nameInRecruitmentDetail = company?.name;
  const industryInRecruitmentDetail = company?.industryName;

  const {data: companyDetailData} = useGetCompanyDetail({
    companyId: String(companyId),
  });
  const {data: reportData} = useReports({
    queryParams: {
      companyIDs: companyId,
      types: [],
      departmentMasterIDs: [],
      limit: 1,
      page: 1,
    },
  });

  const {data: companyInfo} = useGetCompanyInfo({companyId});

  const companyName = companyDetailData?.ok
    ? companyDetailData.value.companyData?.companyName ||
      nameInRecruitmentDetail ||
      ''
    : nameInRecruitmentDetail || '';

  const companyIndustry = isArchivesPage
    ? industryInRecruitmentDetail || ''
    : companyDetailData?.ok
      ? companyDetailData.value.companyData?.industry ||
        industryInRecruitmentDetail ||
        ''
      : industryInRecruitmentDetail || '';

  // companyInfoのロゴを使う
  const companyLogoImageUrl = companyInfo?.ok ? companyInfo.value.logoURL : '';
  const companyMainPhotoImageUrl = recruitmentDetail.companies[0]?.mainImageURL;

  const hasReport = !!(reportData?.ok && reportData.value.reports.length > 0);

  return {
    companyId: companyId ?? 0,
    companyName,
    companyIndustry,
    companyLogoImageUrl,
    companyMainPhotoImageUrl,
    hasReport,
  };
};
